import Store from '@ryangjchandler/spruce';

export default Store;
